<template>
<div class="container">
    <div v-for="(store,index) in storeCartList" :key="index">
        <div class="store">
            <i class="iconfont">&#xe62d;</i>
            <span @click="$router.push({ name: 'HomeStoredetail', query: { id: store.store_id } })">{{store.store_name}}</span>
        </div>
        <ul class="cart-item">
            <li class="buy-item" v-for="goods in store.goods_list" @click="$router.push({name:'HomeGoodsdetail',query:{goods_id:goods.goods_id}})">
                <div class="goods-pic"><img :src="goods.goods_image_url"/></div>
                <div class="goods-info">
                    <dl>
                        <dt class="goods-name">
                            <a>
                                <i class="tag-icon" v-if="goods.xianshi_info">{{goods.xianshi_info.xianshi_title}}</i>
                                <i class="tag-icon" v-if="goods.ifgroupbuy">抢购</i>
                                <i class="tag-icon" v-if="goods.ifmgdiscount">会员折扣</i>
                                <i class="tag-icon" v-if="goods.ifpintuan">拼团</i>
                                <i class="tag-icon" v-if="goods.ifbargain">砍价</i>
                                <i class="tag-icon" v-if="goods.bl_id">优惠套装</i>
                                {{goods.goods_name}}
                            </a>
                        </dt>
                        <dd class="goods-subtotal">
                            <span class="goods-price">{{goods.goods_price}}</span>
                            <span class="goods-count">×{{goods.goods_num}}</span>
                        </dd>
						<dd class="is-label" v-if="goods.miaoinfo.spike_stuts==1">秒杀</dd>
                    </dl>
                </div>

            </li>
            <li class="buy-item"  v-if="store.store_mansong_rule_list && store.store_mansong_rule_list.goods_id !=0 && store.store_mansong_rule_list.mansong_goods_name !=''" @click="$router.push({name:'HomeGoodsdetail',query:{goods_id:store.store_mansong_rule_list.goods_id}})">
                <div class="goods-pic"><img :src="store.store_mansong_rule_list.goods_image_url"/></div>
                    <div class="goods-info">
                        <dl>
                            <dt class="goods-name">
                                <a>
                                    <i class="tag-icon">赠品</i>
                                    {{store.store_mansong_rule_list.mansong_goods_name}}
                                </a>
                            </dt>
                            <dd class="goods-subtotal">
                                <span class="goods-price">0.00</span>
                                <span class="goods-count">×1</span>
                            </dd>
                        </dl>
                    </div>

            </li>
        </ul>
        <div class="cart-subtotal">
            <div v-if="addressApi.allow_offpay==1 && ifshowOffpay" @click="togglePay=true"><mt-cell class="menu-item" title="付款方式" ><span slot="icon" class="left-icon iconfont">&#xe664;</span>{{pay_name}}<i class="indicator iconfont">&#xe650;</i></mt-cell></div>
            <div v-if="store.store_voucher_list.length" @click="toggleVoucher(store.store_id)"><mt-cell class="menu-item" title="代金券" ><span slot="icon" class="left-icon iconfont">&#xe6f2;</span>{{myVoucher[store.store_id]}}<i class="indicator iconfont">&#xe650;</i></mt-cell></div>
            <div class="message">
                <mt-field label="备注" placeholder="店铺订单留言:" type="textarea" v-model="message[store.store_id]" @change="changeMessage(store.store_id)"></mt-field>
            </div>
            <checkout-desc class="desc-item mt-5" title="商品金额" :subtitle="store.store_goods_total"></checkout-desc>
            <checkout-desc class="desc-item" title="优惠" v-if="store.store_mansong_rule_list" :subtitle="store.store_mansong_rule_list.discount" :discount="true"></checkout-desc>
            <checkout-desc class="desc-item" title="运费" :subtitle="addressApi.content[store.store_id]"></checkout-desc> 
            <checkout-desc class="desc-item" title="代金券抵扣" :subtitle="conponsPrice" v-if="store.store_voucher_list.length" :discount="true"></checkout-desc> 
            <checkout-desc class="desc-item" title="本店合计" :subtitle="totalAmount[store.store_id]"></checkout-desc>
        </div>
        <mt-popup v-model="togglePay" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="付款方式" class="common-header">
                    <mt-button slot="left" icon="back" @click="togglePay=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <mt-radio
                        v-model="pay_code"
                        :options="pay_options">
                </mt-radio>
            </div>
        </mt-popup>
        <mt-popup v-model="voucherVisible[store.store_id]" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="代金券" class="common-header">
                    <mt-button slot="left" icon="back" @click="toggleVoucher(store.store_id)"></mt-button>
                    <mt-button slot="right" @click="selectVoucher('',store.store_id,'dpuserd')">不使用</mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <div class="common-voucher common-voucher02" :class="(item.voucher_state != 1)?'disable':''" v-for="(item,index) in store.store_voucher_list" :key="item.voucher_id" @click="selectVoucher(item,store.store_id)">
                    <div class="par"><p>订单满{{item.voucher_limit}}元</p><sub class="sign">￥</sub><span>{{item.voucher_price}}</span></div>
                    <div class="copy">有效期至<p><br>{{$moment.unix(item.voucher_enddate).format('YYYY.MM.DD')}}</p></div>
                    <i></i>
                </div>
            </div>
        </mt-popup>
      
    </div>
    <br>
      <div v-if="hasTyj" @click="voucherVisibleTyj = true">
		  <mt-cell class="menu-item" title="代金券" ><span slot="icon" class="left-icon iconfont">&#xe6f2;</span><span v-if="myVoucher1.tyjName === '不使用'">{{myVoucher1.tyjName}}</span><span v-else style="color:#e93b3d">-{{myVoucher1.tyjName}}</span><i class="indicator iconfont">&#xe650;</i></mt-cell></div>
      <div class="total-money">
        总计金额&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:red">{{handleNum(totalMoney,myVoucher1.voucher_price)}}</span>
      </div>
      <!-- 满送 -->
       <!-- <div>
         {{ totalMoneyStatus.range }}
      </div>
      <div>
          {{ totalMoneyStatus.data }}
      </div> -->
      <!-- 通用卷 -->
         <mt-popup v-model="voucherVisibleTyj" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="代金券" class="common-header">
                    <mt-button slot="left" icon="back" @click="toggleVoucher1()"></mt-button>
                    <mt-button slot="right" @click="toggleVoucher1('noused')">不使用</mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
              <template v-for="(item,idx) in voucherTyjList">
                <div class="common-voucher common-voucher02"  v-if="item.voucher_type == 3" :key="item.voucher_id + idx" :class="(item.voucher_state != 1)?'disable':''" @click="selectVoucher1(item)" >
                    <div class="par"><p>订单满{{item.voucher_limit}}元</p><sub class="sign">￥</sub><span>{{item.voucher_price}}</span></div>
                    <div class="copy">有效期至<p><br>{{$moment.unix(item.voucher_enddate).format('YYYY.MM.DD')}}</p></div>
                    <i></i>
                </div>
              </template>
            </div>
        </mt-popup>
</div>
</template>

<script>
import CheckoutDesc from './CheckoutDesc'
export default {
  name: 'CheckoutStore',
  data () {
    return {
      pay_name: '在线付款',
      pay_code: 'online',
      pay_options: [{
        label: '在线付款',
        value: 'online'
      }, {
        label: '货到付款',
        value: 'offline'
      }],
      pay_list: { online: '在线付款', offline: '货到付款' },
      togglePay: false,
      totalAmount: {},
      myVoucher: [],
	  conponsPrice:0,
      voucherVisible: [],
      message: [],
      hasTyj:false, // 是否有通用卷
      voucherVisibleTyj:false, //通用卷
      myVoucher1:{tyjName: '不使用'}, // 标记商铺是否要用
      voucherTyjList:[], //通用卷
      totalMoney:0,  // 总计
      backendData1:1111,//满送
      backendData2:2222,//满送
      backendData3:3333,//满送
      backendData4:4444,//满送
    }
  },
  components: {
    CheckoutDesc
  },
  props: ['storeCartList', 'addressApi', 'finalTotalList', 'ifshowOffpay','mallVoucherList'],
  created: function () {
    console.log(this.storeCartList,'storeCartList')
    for (var store_id in this.storeCartList) {
      this.calcOrder(store_id)
    }
    for(let attr in this.mallVoucherList) {
      this.hasTyj = true
      this.voucherTyjList.push(this.mallVoucherList[attr]);
    }
    //console.log("自动找到代金券");
  },
  watch: {
    pay_code: function (pay_code) {
      this.pay_name = this.pay_list[pay_code]
      this.togglePay = false
      this.$emit('selectPay', pay_code)
    }
  },
  computed: {
    // 满送  根据金额范围返回不同数据
  totalMoneyStatus() {
    if (this.totalMoney > 1000) {
      return {
        range: '大于1000',
        data: this.backendData1
      };
    } else if (this.totalMoney > 800) {
      return {
        range: '大于800小于1000',
        data: this.backendData2
      };
    } else if (this.totalMoney > 500) {
      return {
        range: '大于500小于800',
        data: this.backendData3
      };
    } else {
      return {
        range: '小于等于500',
        data: this.backendData4
      };
    }
  }
},
mounted(){
   this.$nextTick(() => {
        this.autoSelectDefaultVoucher();
   });
},
  methods: {
    autoSelectDefaultVoucher(){
      let targetVoucher = null;
      for (let key in this.mallVoucherList) {
          if (this.mallVoucherList[key].voucher_state == 1) {
              targetVoucher = this.mallVoucherList[key];
              break; // 找到一张就停止
          }
      }
      console.log("自动找到代金券",targetVoucher);
      console.log("自动找到代金券-666",this.mallVoucherList);
      if(this.mallVoucherList && Object.keys(this.mallVoucherList).length > 0){
         console.log("自动找到代金券--->准备自动选择--->");
         this.selectVoucher1(targetVoucher,0);

      }
    },
    changeMessage (store_id) {
      this.$emit('changeMessage', this.message[store_id], store_id)
    },
    selectVoucher (voucherInfo, store_id,type) {
      let money = this.myVoucher[store_id].substring(0,this.myVoucher[store_id].length-1)
      console.log(money,'myVoucher[store.store_id]')
      this.toggleVoucher(store_id)
      this.$emit('selectVoucher', voucherInfo, store_id)
      this.storeCartList[store_id].store_voucher_info = voucherInfo
      if (type) {
        this.calcOrder(store_id,money)
      } else {
        this.calcOrder(store_id)
      }
      
    },

    calcOrder (store_id,money) {
      console.log(this.storeCartList,'123456789')
      let price = parseFloat(this.finalTotalList[store_id])
      if (this.storeCartList[store_id].store_voucher_list.length) {
        if (this.storeCartList[store_id].store_voucher_info) {
          price -= parseFloat(this.storeCartList[store_id].store_voucher_info.voucher_price)
          if (typeof (this.myVoucher[store_id]) === 'undefined') {
            this.myVoucher[store_id] = ''
          }
		  this.conponsPrice = this.storeCartList[store_id].store_voucher_info.voucher_price;
          this.myVoucher.splice(store_id, 1, this.storeCartList[store_id].store_voucher_info.voucher_price + '元')
       } else {
		  this.conponsPrice = 0
          this.myVoucher.splice(store_id, 1, '不使用')
        }
      }
      if (price < 0) {
        price = 0
      }
      this.totalAmount[store_id] = price
      this.totalMoney = 0 
      for (let attr in this.totalAmount) {
         this.totalMoney = this.numAdd(this.totalMoney,this.totalAmount[attr])//总计金额
      }
      // if(money) {
      //   this.totalMoney = 0

      //   this.totalAmount[store_id] = price
      //   = this.numAdd(this.totalMoney,Number(money))

      // } else {

      //   this.totalMoney = this.numAdd(this.totalMoney,this.totalAmount[store_id])
      // }
    
    },
    toggleVoucher (store_id) {
      if (typeof (this.voucherVisible[store_id]) === 'undefined') {
        this.voucherVisible[store_id] = false
      }
      this.voucherVisible.splice(store_id, 1, !this.voucherVisible[store_id])
    },
    selectVoucher1(voucherInfo, store_id) {
      this.myVoucher1 = {...voucherInfo,tyjName:voucherInfo.voucher_price + '元'}
      this.$emit('mallvoucher',this.myVoucher1)
      this.voucherVisibleTyj = false
    },
    toggleVoucher1 (type) {
      this.voucherVisibleTyj = !this.voucherVisibleTyj
      if (type) {
         this.myVoucher1 = { tyjName: '不使用'}
         this.$emit('mallvoucher',this.myVoucher1)
        // this.totalAmount[store_id] = parseFloat(this.finalTotalList[store_id]) > 0 ? parseFloat(this.finalTotalList[store_id]) : 0 
      }
    },
     // 2数相减
    accSub(arg1, arg2) {
        var r1, r2, m, n;
        try {
            r1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
        n = (r1 >= r2) ? r1 : r2;
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    handleNum(arg1,arg2) {
      let price = arg1
      if(arg2) {
        price = this.accSub(arg1,arg2)
        if(Number(price) < 0) {
          price = 0
        }
      }
      return Number(price).toFixed(2)
    },
    numAdd(num1, num2) {
        num1 = num1 || 0
        num2 = num2 || 0
        var baseNum, baseNum1, baseNum2;
        try {
            baseNum1 = num1.toString().split(".")[1].length;
        } catch (e) {
            baseNum1 = 0;
        }
        try {
            baseNum2 = num2.toString().split(".")[1].length;
        } catch (e) {
            baseNum2 = 0;
        }
        baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
        let result = (num1 * baseNum + num2 * baseNum) / baseNum
        let newArr = result.toString().split(".")
        if (newArr[1] && newArr[1].length > 2) {
            result = result.toFixed("2")
        }
        return Number(result);
    }
  }
}
</script>

<style scoped lang="scss">
.store{    position: relative;
    z-index: 1;
    display: block;
    height: 0.9rem;
    padding: 0.5rem;
    font-size: 0.7rem;
    line-height: 0.9rem;
    border-bottom: solid 0.05rem #EEE;
}
.store i{
        display: inline-block;
        width: 0.8rem;
        height: 0.9rem;
        margin-right: 0.2rem;
        vertical-align: middle;
    }
    .cart-item{background-color: #FFF;
        border-bottom: solid 0.05rem #EEE;}
    .buy-item{    display: block;
        position: relative;
        z-index: 1;
        margin:0 0.5rem;
        padding: 0.5rem 0;}
    .buy-item .goods-pic{display: block;
        width: 2.7rem;
        height: 2.7rem;
        padding: 0.2rem;
        position: absolute;
        z-index: 1;
        top: 0.5rem;
        left: 0rem;
        border: solid 0.05rem #EEE;
        border-radius: 0.2rem;}
.buy-item .goods-pic img{width: 2.7rem;
    height: 2.7rem;}
.buy-item .goods-info{    display: block;
        vertical-align: top;
        height: 3.1rem;
        margin-left:4rem;
        position: relative;
        z-index: 1;}
.buy-item .goods-info .goods-name a {
    display: block;
    height:1rem;
    font-size: 0.7rem;
    color: #666666;
    line-height: 1rem;
    overflow: hidden;
}
.buy-item .goods-info  .goods-type {
    overflow: hidden;
    white-space: nowrap;
    width: 70%;
    height: 0.9rem;
    font-size: 0.45rem;
    line-height: 0.9rem;
    color: #999;
    text-overflow: ellipsis;
}
.buy-item .goods-info  .goods-subtotal {
    display: block;
    height: 1rem;
    margin: 0 0.5rem 0 0rem;
    line-height: 1rem;
    font-size: 0.7rem;
    position: relative;
    z-index: 1;
}
.is-label{
	font-size:.5rem;color: #e93b3d;border: .045rem solid #e93b3d;border-radius: .13rem;padding:0 .2rem;margin-right:.3rem;width: fit-content;
}
.buy-item .goods-info  .goods-subtotal .goods-price {
    color: #DB4453;
    font-size: 0.7rem;
    font-weight: 600;
}
.buy-item .goods-info  .goods-subtotal  .goods-count {
    font-size: 0.7rem;
    line-height: 1rem;
    position: absolute;
    z-index: 1;
    top: 0rem;
    right: 1rem;
}
 .cart-subtotal{}
.cart-subtotal dl {
    position: relative;
    z-index: 1;
    height: 1rem;
    padding: 0.4rem 0 0;
    font-size: 0;
}
.cart-subtotal dt {
    position: absolute;
    z-index: 1;
    top: 0.4rem;
    left: 0.4rem;
    display: block;
    width: 50%;
    height: 1rem;
    font-size: 0.6rem;
    line-height: 1rem;
}
.cart-subtotal dd {
    height: 1rem;
    margin: 0 0.5rem 0 50%;
    text-align: right;
    font-size: 0.6rem;
    line-height: 1rem;
}
.cart-subtotal .message {
    position: relative;
    z-index: 1;
    display: block;
    padding-top: 0.4rem;
}
.desc-item {
    height: 1.5rem;
}
.common-voucher{margin:0.5rem auto}
.left-icon{float:left;font-size:0.9rem;margin-right:0.2rem;}
.total-money {
  text-align:right;
  font-size:0.8rem;
  padding:0 15px;
  margin-top:15px;
  span {
    color:red;
  }
}
</style>
